export default __webpack_public_path__ + "cca37063c30166fb7ea738ebfd867785.svg";